/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateUserPaymentMethodRequestPaymentMethod } from './CreateUserPaymentMethodRequestPaymentMethod';
import {
    CreateUserPaymentMethodRequestPaymentMethodFromJSON,
    CreateUserPaymentMethodRequestPaymentMethodFromJSONTyped,
    CreateUserPaymentMethodRequestPaymentMethodToJSON,
} from './CreateUserPaymentMethodRequestPaymentMethod';

/**
 * 
 * @export
 * @interface CreateUserPaymentMethodRequest
 */
export interface CreateUserPaymentMethodRequest {
    /**
     * 
     * @type {CreateUserPaymentMethodRequestPaymentMethod}
     * @memberof CreateUserPaymentMethodRequest
     */
    paymentMethod?: CreateUserPaymentMethodRequestPaymentMethod;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserPaymentMethodRequest
     */
    isDefault?: boolean;
}

/**
 * Check if a given object implements the CreateUserPaymentMethodRequest interface.
 */
export function instanceOfCreateUserPaymentMethodRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateUserPaymentMethodRequestFromJSON(json: any): CreateUserPaymentMethodRequest {
    return CreateUserPaymentMethodRequestFromJSONTyped(json, false);
}

export function CreateUserPaymentMethodRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserPaymentMethodRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentMethod': !exists(json, 'payment_method') ? undefined : CreateUserPaymentMethodRequestPaymentMethodFromJSON(json['payment_method']),
        'isDefault': !exists(json, 'is_default') ? undefined : json['is_default'],
    };
}

export function CreateUserPaymentMethodRequestToJSON(value?: CreateUserPaymentMethodRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payment_method': CreateUserPaymentMethodRequestPaymentMethodToJSON(value.paymentMethod),
        'is_default': value.isDefault,
    };
}

